import { ref, computed, watch } from 'vue';
import { format, addDays, isBefore, startOfDay, parseISO } from 'date-fns';
import PrevDaysButton from './components/PrevDaysButton.vue';
import NextDaysButton from './components/NextDaysButton.vue';
import { formatDate } from '../../../../../helpers/formatDate.js';
import { PerfectScrollbar } from 'vue3-perfect-scrollbar';
import { pl } from 'date-fns/locale';
import { useField } from 'vee-validate';
import { useNumberOfVisibleDays } from '../Calendar/hooks/useNumberOfVisibleDays.js';
import 'vue3-perfect-scrollbar/style.css';


export default {
  __name: 'Calendar',
  props: {
    schedule: {
        type: Object,
        required: true,
    },
    status: {
        type: String,
        required: true,
    },
},
  setup(__props, { expose }) {
  expose();

const props = __props;


const {
    value: selectedCallDateValue,
    errors: selectedCallDateErrors,
    errorMessage: selectedCallDateErrorMsg,
} = useField('selectedConsultationDate');
const { numberOfVisibleDays } = useNumberOfVisibleDays();

const visibleStartDate = ref(
    selectedCallDateValue.value?.date ? parseISO(selectedCallDateValue.value.date) : new Date(),
);

const maxSlots = computed(() => {
    return Math.max(...Object.values(props.schedule).map((slots) => Object.keys(slots).length));
});

const getDays = (startDate, numberOfDays) => {
    const days = [];
    let currentDate = new Date(startDate);
    for (let i = 0; i < numberOfDays; i++) {
        days.push({
            date: format(currentDate, 'yyyy-MM-dd'),
            weekday: format(currentDate, 'EEE', { locale: pl }),
        });
        currentDate = addDays(currentDate, 1);
    }
    return days;
};

const currentWeekDays = computed(() => getDays(visibleStartDate.value, numberOfVisibleDays.value));

const setPreviousDays = () => {
    visibleStartDate.value = addDays(visibleStartDate.value, -numberOfVisibleDays.value);
};

const setNextDays = () => {
    visibleStartDate.value = addDays(visibleStartDate.value, numberOfVisibleDays.value);
};

const isPreviousDaysDisabled = computed(() => {
    const today = startOfDay(new Date());
    return isBefore(visibleStartDate.value, addDays(today, 1));
});

const getClass = (date, hour) => {
    const slotStatus = props.schedule[date] && props.schedule[date][hour];
    if (!slotStatus) return 'not-available';

    if (isBefore(date, startOfDay(new Date()))) {
        return 'not-available';
    }

    return {
        available: slotStatus === 'available',
        reserved: slotStatus === 'reserved',
        'not-available': slotStatus === '-',
        selected: isSelected(date, hour),
    };
};

const isSelected = (date, hour) => {
    return (
        selectedCallDateValue.value &&
        selectedCallDateValue.value.date === date &&
        selectedCallDateValue.value.hour === hour
    );
};

const selectTimeSlot = (date, hour) => {
    if (props.schedule[date] && props.schedule[date][hour] === 'available') {
        selectedCallDateValue.value = { date, hour };
    }
};

const generateSlotsForDay = (date) => {
    const slots = props.schedule[date] ? Object.keys(props.schedule[date]) : [];
    while (slots.length < maxSlots.value) {
        slots.push('-');
    }
    return slots.map((time) => ({ time }));
};

const __returned__ = { props, selectedCallDateValue, selectedCallDateErrors, selectedCallDateErrorMsg, numberOfVisibleDays, visibleStartDate, maxSlots, getDays, currentWeekDays, setPreviousDays, setNextDays, isPreviousDaysDisabled, getClass, isSelected, selectTimeSlot, generateSlotsForDay, ref, computed, watch, get format() { return format }, get addDays() { return addDays }, get isBefore() { return isBefore }, get startOfDay() { return startOfDay }, get parseISO() { return parseISO }, PrevDaysButton, NextDaysButton, get formatDate() { return formatDate }, get PerfectScrollbar() { return PerfectScrollbar }, get pl() { return pl }, get useField() { return useField }, get useNumberOfVisibleDays() { return useNumberOfVisibleDays } }
Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true })
return __returned__
}

}